<template>
    <div class="app-container">
      <!-- Onboarding Progress Overview -->
      <BjDivider>{{ $t('AccountManagement.dashboard.Onboarding') }}</BjDivider>
      <div style="width: 100%;height:270px;display: flex;justify-content: space-around;text-align: center">
        <!-- css展示全部用户 左侧24% -->
        <div style="width:24%;height:220px;">
          <div style="width: 100%;height: 70%;line-height: 180px;font-size: 88px;">{{onboardingData.totalCustomer}}</div>
          <span style="font-size: 20px;">{{ $t('AccountManagement.dashboard.Total') }}</span>
        </div>
        <!-- css展示两种状态 左侧14% -->
        <div style="width:14%;height:220px;">
          <div style="height:48%">
            <div style="line-height: 100px;font-size: 40px;height: 80%;">{{onboardingData.unfinishedTotal}}</div>
            <span>{{ $t('AccountManagement.dashboard.Pending') }}</span>
          </div>
          <div style="height:48%">
            <div style="line-height: 100px;font-size: 40px;height: 80%;">{{onboardingData.finishedTotal}}</div>
            <span>{{ $t('AccountManagement.dashboard.Initial') }}</span>
          </div>
        </div>
        <!-- echarts展示数据饼图 右侧60% -->
        <div style="width:60%;height:200px;display: flex;justify-content: space-around;align-items: flex-end;">
          <div style="width:100px;height: 100px;font-size: x-large;">
            <el-progress type="circle" :percentage="Math.trunc(onboardingData.skuTotal / onboardingData.finishedTotal * 100)" :format="format1" :width="100" :stroke-width="15"></el-progress>
            <span>{{ $t('AccountManagement.dashboard.SKU') }}</span>
          </div>
          <div style="width:100px;height: 100px;font-size: x-large;">
            <el-progress type="circle" :percentage="Math.trunc(onboardingData.storeTotal / onboardingData.finishedTotal * 100)" :format="format2" :width="100" :stroke-width="15"></el-progress>
            <span>{{ $t('AccountManagement.dashboard.Store') }}</span>
          </div>
          <div style="width:100px;height: 100px;font-size: x-large;">
            <el-progress type="circle" :percentage="Math.trunc(onboardingData.poTotal / onboardingData.finishedTotal * 100)" :format="format3" :width="100" :stroke-width="15"></el-progress>
            <span>{{ $t('AccountManagement.dashboard.PO') }}</span>
          </div>
          <div style="width:100px;height: 100px;font-size: x-large;">
            <el-progress type="circle" :percentage="Math.trunc(onboardingData.orderTotal / onboardingData.finishedTotal * 100)" :format="format4" :width="100" :stroke-width="15"></el-progress>
            <span>{{ $t('AccountManagement.dashboard.Order') }}</span>
          </div>
        </div>
      </div>
      <!-- Customer Operational Milestone Tracker -->
      <BjDivider>{{ $t('AccountManagement.dashboard.Tracker') }}
        <template slot="right">
          <BjSelectLov v-model="onboardingCusSelected" multiple :option-list="onboardingCusList" :placeholder="$t('AccountManagement.dashboard.Customer')" @change="chooseCus"/>
        </template>
      </BjDivider>
      <div v-show="panelDataList.length > 0" v-for="(item,index) in panelDataList" :key="index" class="panelBig" style="width:100%;">
        <div class="panel" style="width:100%;margin-bottom: 10px;">
          <div style="width:99%;height:20px;margin-left: 1%;margin-bottom: 10px;">
            <i v-if="item.isShow" class="el-icon-caret-bottom"></i>
            <i v-else class="el-icon-caret-right"></i>
            <span @click="item.isShow=!item.isShow" style="cursor: pointer;">{{item.name}}</span>
          </div>
          <div v-if="item.isShow" style="width:100%;height:180px;display: flex;justify-content: space-around;">
            <div style="width:22%;height:180px;border: 2px solid #EBEEF5;padding:10px 20px;display: flex;justify-content: space-around;flex-direction: column;">
              <div style="font-size: larger;">{{ $t('AccountManagement.dashboard.SKUi') }}</div>
              <div><el-checkbox disabled v-model="item.skuFirst" :true-label="1" :false-label="0">{{ $t('AccountManagement.dashboard.SKUFirst') }}</el-checkbox></div>
              <div>{{ $t('AccountManagement.dashboard.SKUCurrent') }} : {{ item.skuCurrentNum || 0 }}</div>
              <div>{{ $t('AccountManagement.dashboard.SKUEstimated') }} : {{ item.skuEstimateNum || 0 }}</div>
              <div style="text-align:right;"><el-button type="primary" @click="onComplete1(item,'sku')">{{ $t('AccountManagement.dashboard.Complete') }}</el-button></div>
            </div>
            <div style="width:22%;height:180px;border: 2px solid #EBEEF5;padding:10px 20px;display: flex;justify-content: space-around;flex-direction: column;">
              <div style="font-size: larger;">{{ $t('AccountManagement.dashboard.Storei') }}</div>
              <div><el-checkbox disabled v-model="item.storeFirst" :true-label="1" :false-label="0">{{ $t('AccountManagement.dashboard.StoreFirst') }}</el-checkbox></div>
              <div><el-checkbox disabled v-model="item.storeApiTest" :true-label="1" :false-label="0">{{ $t('AccountManagement.dashboard.StoreAPI') }}</el-checkbox></div>
              <div style="width:100%;height:20px"> </div>
              <div style="text-align:right;"><el-button type="primary" @click="onComplete2(item,'store')">{{ $t('AccountManagement.dashboard.Complete') }}</el-button></div>
            </div>
            <div style="width:22%;height:180px;border: 2px solid #EBEEF5;padding:10px 20px;display: flex;justify-content: space-around;flex-direction: column;">
              <div style="font-size: larger;">{{ $t('AccountManagement.dashboard.POi') }}</div>
              <div><el-checkbox disabled v-model="item.poFirst" :true-label="1" :false-label="0">{{ $t('AccountManagement.dashboard.POFirst') }}</el-checkbox></div>
              <div><el-checkbox disabled v-model="item.poArrived" :true-label="1" :false-label="0">{{ $t('AccountManagement.dashboard.POArrived') }}</el-checkbox></div>
              <div><el-checkbox disabled v-model="item.poReceived" :true-label="1" :false-label="0">{{ $t('AccountManagement.dashboard.POReceived') }}</el-checkbox></div>
              <div style="width:100%;height:20px"> </div>
            </div>
            <div style="width:22%;height:180px;border: 2px solid #EBEEF5;padding:10px 20px;display: flex;justify-content: space-around;flex-direction: column;">
              <div style="font-size: larger;">{{ $t('AccountManagement.dashboard.Orderi') }}</div>
              <div><el-checkbox disabled v-model="item.orderFirst" :true-label="1" :false-label="0">{{ $t('AccountManagement.dashboard.OrderFirst') }}</el-checkbox></div>
              <div><el-checkbox disabled v-model="item.orderDispatched" :true-label="1" :false-label="0">{{ $t('AccountManagement.dashboard.OrderDispatched') }}</el-checkbox></div>
              <div style="width:100%;height:20px"> </div>
              <div style="width:100%;height:20px"> </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import pageMiXin from '@/utils/page-mixin.js';
    import { funConfigApi } from '@/api';
  
    export default {
      name: 'onboardingDashboard',
      mixins: [pageMiXin],
      data() {
        return {
          // 进度条数据
          onboardingData:{},
          skuNum:null,
          storeNum:null,
          poNum:null,
          orderNum:null,

          // 入场客户下拉选中数据
          onboardingCusSelected:[],
          // 入场客户下拉列表
          onboardingCusList:[],

          // 折叠面板数据
          panelDataList: [],
          isShow:false,
        };
      },
      created(){
        this.getOnboardingData()
      },
      methods: {
        getOnboardingData(){
          // 仪表盘统计信息
          funConfigApi.getOnboardingDashboard().then(res=>{
            this.skuNum = res.skuTotal
            this.storeNum = res.storeTotal
            this.poNum = res.poTotal
            this.orderNum = res.orderTotal
            this.onboardingData = res
          })
          // 入场客户下拉框
          funConfigApi.getOnboardingCompanyPull().then(res=>{
            this.onboardingCusList = res.map(item=>{
              return {label:item.companyName,value:item.onboardingIds}
            })
          })
        },
        // 进度条回显数据
        format1(percentage){
          return `${this.skuNum}`
        },
        format2(percentage){
          return `${this.storeNum}`
        },
        format3(percentage){
          return `${this.poNum}`
        },
        format4(percentage){
          return `${this.orderNum}`
        },
        // 入场客户下拉列表触发
        chooseCus(n,m){
          // console.log(n,m);
          if(n.length > 0){
            // 根据客户查询信息
            funConfigApi.getOnboardingQueryCOMT(n).then(res=>{
              this.panelDataList = res
            })
          }else{
            this.panelDataList = []
          }
        },
        // 第一折叠面板按钮 onComplete1
        onComplete1(item,name){
          // console.log(item,name,'onComplete1');
          funConfigApi.getOnboardingManuallySku(item.onboardingId).then(res=>{
            // console.log(res,'onComplete1');
            if(!res.failed){
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.panelDataList = []
              this.onboardingCusSelected = []
              this.getOnboardingData()
            }
          })
        },
        // 第二折叠面板按钮 onComplete2
        onComplete2(item,name){
          // console.log(item,name,'onComplete2');
          funConfigApi.getOnboardingManuallyStore(item.onboardingId).then(res=>{
            // console.log(res,'onComplete2');
            if(!res.failed){
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.panelDataList = []
              this.onboardingCusSelected = []
              this.getOnboardingData()
            }
          })
        },
      },
    };
  </script>
  <style lang="scss" scoped>
    ::v-deep .el-progress__text{
      font-size: 20px !important;
    }
  </style>
  